import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { PRICE, TOTAL_VALUE } from '../data/product';
export function Close() {
  return <section className="track-night lane-band w-full" data-id="element-84" data-mp="1uycn6jzhvc7w">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:py-20" data-id="element-85" data-mp="1ux1nav966om2">
        <h2 className="font-display text-3xl text-chalk sm:text-5xl" data-id="element-86" data-mp="1q01c65xgqvo3">
          Stop making up practice. <span className="text-hl" data-id="element-87" data-mp="1l0f0w2173phx">Start running it.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-chalk/80" data-id="element-88" data-mp="1g9gjt08dundm">
          Six volumes, 121 Fence Card Sessions and five bonuses. Your whole track
          season for every event group: sprints, hurdles, relays, jumps, throws
          and distance, at three levels, rain or shine.
        </p>

        <div className="mt-7" data-id="element-89" data-mp="129nt34wuw75n">
          <Countdown size="sm" data-id="element-90" data-mp="129xe0e31no4h" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-hl bg-navy-deep/60 px-5 py-4 text-left" data-id="element-91" data-mp="12bru9f3des28">
          <div data-id="element-92" data-mp="3ven39wzp7icp">
            <span className="block text-[10px] font-semibold uppercase tracking-widest text-hl" data-id="element-93" data-mp="3ve3vva7occcx">Complete megapack</span>
            <span className="text-[15px] font-semibold text-chalk" data-id="element-94" data-mp="42kbt3prhwfv">Track Coach Ready: 6 Volumes + 5 Bonuses</span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-95" data-mp="3qfslmydgvzu6">
            <span className="text-[15px] text-chalk/60 line-through" data-id="element-96" data-mp="3qglnpm1he15z">${TOTAL_VALUE}</span>
            <span className="font-display text-4xl font-bold leading-none text-chalk" data-id="element-97" data-mp="i1a8ii8o5u3p">${PRICE}</span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-98" data-mp="82cnvqed6kpz">
          <CtaButton data-id="element-99" data-mp="81jcgc4gn71i">Yes, I want Track Coach Ready — ${PRICE}</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-chalk/65" data-id="element-100" data-mp="d0mgpucm998f">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-101" data-mp="2xs68ayeftgu4">
              <span className="h-1.5 w-1.5 rounded-full bg-hl" data-id="element-102" data-mp="2xpa976qusm43" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}